interface TypingIndicatorProps {
  isVisible: boolean;
}

/** docs/ui/component-inventory.md's `TypingIndicator`: a bouncing-dots
 * bubble, visible/hidden — no other states. */
export function TypingIndicator({ isVisible }: TypingIndicatorProps) {
  if (!isVisible) return null;

  return (
    <div className="flex justify-start px-4 py-1">
      <div className="flex items-center gap-1 rounded-2xl bg-muted px-4 py-3">
        {[0, 1, 2].map((index) => (
          <span
            key={index}
            className="h-1.5 w-1.5 animate-bounce rounded-full bg-muted-foreground"
            style={{ animationDelay: `${index * 120}ms` }}
          />
        ))}
      </div>
    </div>
  );
}
